export default function AboutSection() {
  return (
    <section className="bg-secondary-50/60 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-12 max-w-4xl">
        <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-6">
          WHY PANDABUY SHEET
        </span>

        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
          Your Ultimate{' '}
          <span className="inline-flex items-center gap-2">
            Curated
            <span className="inline-block w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden align-middle mx-1">
              <img
                src="https://readdy.ai/api/search-image?query=Closeup%20of%20soft%20cream%20cashmere%20fabric%20texture%20with%20gentle%20folds%20warm%20natural%20daylight%20minimal%20studio%20setting%20neutral%20beige%20background%20luxury%20textile%20photography&width=96&height=96&seq=about-inline-01-v2&orientation=squarish"
                alt="Curated fashion item"
                className="w-full h-full object-cover"
              />
            </span>
          </span>{' '}
          Shopping List{' '}
          <span className="inline-block w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden align-middle mx-1">
            <img
              src="https://readdy.ai/api/search-image?query=Closeup%20of%20brushed%20gold%20watch%20dial%20with%20minimalist%20hands%20and%20markers%20soft%20studio%20lighting%20dark%20charcoal%20background%20elegant%20product%20detail%20photography&width=96&height=96&seq=about-inline-02-v2&orientation=squarish"
              alt="Curated accessory item"
              className="w-full h-full object-cover"
            />
          </span>{' '}
          Hub{' '}
          <span className="inline-block w-10 h-10 md:w-12 md:h-12 rounded-lg overflow-hidden align-middle mx-1">
            <img
              src="https://readdy.ai/api/search-image?query=Flat%20lay%20of%20a%20minimalist%20leather%20keychain%20and%20small%20suede%20pouch%20on%20a%20warm%20terracotta%20surface%20soft%20overhead%20lighting%20clean%20product%20photography&width=96&height=96&seq=about-inline-03-v2&orientation=squarish"
              alt="Curated product detail"
              className="w-full h-full object-cover"
            />
          </span>
        </h2>

        <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
          We built this <strong>pandabuyspreadsheet</strong> hub because finding reliable, updated, and well-organized spreadsheet collections shouldn't be a chore. Our team curates the best spreadsheet finds daily, verifies seller quality, and organizes everything into an intuitive browsing experience. Whether you are hunting for sneakers, streetwear, luxury-inspired pieces, or budget-friendly gems, our <strong>pandabuyspreadsheet</strong> collections give you a head start every single time.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <a
            href="/article/pandabuy-spreadsheet-ultimate-guide"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            Read Beginner Guide
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-700 font-semibold text-sm hover:bg-foreground-50 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            Visit Main Hub
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}